import { useQuery } from '@tanstack/react-query'
import { fetchPartyLeader, candidateKeys } from '@/services/candidates'

export function usePartyLeader(partyId: string | undefined) {
  const leaderQuery = useQuery({
    queryKey: candidateKeys.partyLeader(partyId!),
    queryFn: () => fetchPartyLeader(partyId!),
    enabled: !!partyId,
  })

  return {
    leader: leaderQuery.data,
    isLoading: leaderQuery.isLoading,
    error: leaderQuery.error,
  }
}
